import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { GoogleApiWrapper } from 'google-maps-react';
import qs from 'qs';
import {
  DialogContainer,
  Divider,
} from 'react-md';

import { invokeBackendApi } from '../../libs/awsLib';

import './Journey.css';
import JourneyToolbar from './JourneyToolbar';
import SegmentsTable from './SegmentsTable';
import JourneyMap from './JourneyMap';

export default GoogleApiWrapper({
  apiKey: ('AIzaSyA4JZOT3-1YNyPmfIu-qNIu7CYCwYzTJeA'),
})(withRouter(injectIntl(class Journey extends Component {
  static propTypes = {
    journeys: PropTypes.array,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    initialJourneyIndex: PropTypes.number,
    onHide: PropTypes.func,
    google: PropTypes.object,
    userAttributes: PropTypes.shape({
      isPsy: PropTypes.bool.isRequired,
    }),
    driverId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      journey: {},
      segments: [],
      activeSegment: undefined,
    };
  }

  componentWillReceiveProps = ({ initialJourneyIndex }) => {
    this.setState({ journeyIndex: initialJourneyIndex, activeSegment: undefined }, () => {
      if (initialJourneyIndex !== undefined) {
        this.loadJourney();
        this.loadSegments();
      }
    });
  }

  onInfoWindowClose = () => {
    this.setState({
      activeSegment: undefined,
    });
  }

  onMapReady = map => this.setState({ map });

  loadJourney = () => {
    this.journey()
      .then(journey => this.setState({ isLoading: false, journey }, () => {
        const { google } = this.props;
        const { map } = this.state;
        if (map) {
          const gBounds = new google.maps.LatLngBounds(journey.bounds && journey.bounds.southwest, journey.bounds && journey.bounds.northeast);
          map.fitBounds(gBounds);
        }
      }))
      .catch(e => alert(e));
  }

  loadSegments = () => {
    this.segments()
      .then((segments) => {
        segments.sort((a, b) => {
          if (a.start < b.start) { return -1; }
          if (a.start > b.start) { return 1; }
          return 0;
        });
        this.setState({ segments });
      })
      .catch(e => alert(e));
  }

  handleOnHide = () => {
    this.setState({ isLoading: true });
    this.props.onHide();
  }

  handleClickOnPreviousJourney = () => {
    const { journeyIndex } = this.state;
    if (journeyIndex === 0) return;
    this.componentWillReceiveProps({ initialJourneyIndex: journeyIndex - 1 });
  }
  handleClickOnNextJourney = () => {
    const { journeyIndex } = this.state;
    const { journeys: { length } } = this.props;
    if (journeyIndex === length - 1) return;
    this.componentWillReceiveProps({ initialJourneyIndex: journeyIndex + 1 });
  }
  journey = () => {
    const { journeyIndex } = this.state;
    const { location: { search }, journeys, driverId } = this.props;
    const driver = (qs.parse(search.replace('?', '')).driver || driverId);
    const { journeyId } = journeys[journeyIndex];
    const path = driver ? `/drivers/${driver}/journeys/${journeyId}` : `/journeys/${journeyId}`;
    return invokeBackendApi({ path });
  }

  segments = () => {
    const { journeyIndex } = this.state;
    const { location: { search }, journeys, driverId } = this.props;
    const driver = (qs.parse(search.replace('?', '')).driver || driverId);
    const { journeyId } = journeys[journeyIndex];
    const path = driver ? `/drivers/${driver}/journeys/${journeyId}` : `/journeys/${journeyId}`;
    return invokeBackendApi({ path: `${path}/segments` });
  }

  handleClickOnSegment = (segment) => {
    this.setState({ activeSegment: segment });
  }

  render() {
    const {
      isLoading, journey, activeSegment, journeyIndex, segments,
    } = this.state;
    if (isLoading) return false;
    const { journeys, google, userAttributes } = this.props;
    const segementsOverspeed = segments.filter(s => s.overspeed !== 'noOverSpeed');

    return (
      !isLoading &&
      <DialogContainer
        id="simple-full-page-dialog"
        visible={journeyIndex !== undefined && !isLoading}
        fullPage
        onHide={this.handleOnHide}
        aria-labelledby="simple-full-page-dialog-title"
      >
        {journey && <JourneyToolbar
          journey={journey}
          journeyIndex={journeyIndex}
          journeysSize={journeys.length}
          handleOnHide={this.handleOnHide}
          handleClickOnPreviousJourney={this.handleClickOnPreviousJourney}
          handleClickOnNextJourney={this.handleClickOnNextJourney}
        />}
        <section className="md-toolbar-relative" style={{ height: 'calc(100vh - 64px)' }}>
          <JourneyMap
            google={google}
            journey={journey}
            segments={segments}
            activeSegment={activeSegment}
            onSegmentClick={this.handleClickOnSegment}
            onInfoWindowClose={this.onInfoWindowClose}
            onMapReady={this.onMapReady}
          />
          <div className="speedings">
            <SegmentsTable
              journey={journey}
              segments={segementsOverspeed}
              activeSegment={activeSegment}
              onSegmentClick={this.handleClickOnSegment}
              userAttributes={userAttributes}
            />
            <Divider />
          </div>
        </section>

      </DialogContainer>
    );
  }
})));



// WEBPACK FOOTER //
// ./src/components/Journey/index.js